/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react'
import CN from 'classnames'

import columnsStructure from './columnsStructure'
import Table from './Table'

import './DataTable.scss'

export const DataTable = ({
  itemData,
  className,
  selectAll,
  setSelectAll,
  setSelectedRowIds,
  selectedRowIds,
  tableVariables,
  setTableVariables,
  totalRowCount,
  setIsLoading,
  setPageNumber,
  pageNumber,
  setUpdateCarrier,
  bulkSlipNo,
  setIsUpdatePackageModalOpen,
  setIsUpdateCourrierModalOpen,
  integrationType,
  setIntegrationType,

  ...restProps
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const columns = useMemo(() => {
    // Start with the full columns structure
    let filteredColumns = [...columnsStructure]
    if (integrationType == 'Paperless') {
      filteredColumns = filteredColumns.filter((col) => col.id !== 'bulkSlipNo')
    }
    if (integrationType == 'ICSWms') {
      filteredColumns = filteredColumns.filter((col) => col.id !== 'consNo')
    }

    // Return the final filtered columns based on the status
    return filteredColumns
  }, [integrationType])

  useEffect(() => {
    if (itemData?.length > 0) {
      setData([...itemData])
    }
  }, [itemData])

  return (
    <div className={CN('data-table w-full text-sm', className)} {...restProps}>
      <Table
        columns={columns}
        data={itemData}
        selectAll={selectAll}
        setFetchAll={setSelectAll}
        setSelectedRowIds={setSelectedRowIds}
        selectedRowIds={selectedRowIds}
        setTableVariables={setTableVariables}
        tableVariables={tableVariables}
        totalRowCount={totalRowCount}
        setIsLoading={setIsLoading}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
        setUpdateCarrier={setUpdateCarrier}
        setIsUpdatePackageModalOpen={setIsUpdatePackageModalOpen}
        setIsUpdateCourrierModalOpen={setIsUpdateCourrierModalOpen}
      />
    </div>
  )
}

export default DataTable
